import axios from 'axios';
import {languageMapping} from 'constants/languageMapping';

const blogListApi = (per_page = 10, lang = 0) => {
  return axios.get(
    `https://api.himegamiprotocol.org/api/v1/user/shinobi-blogs?language=${lang}&per_page=10`,
    // `http://dev1.solashi.com:2240/api/v1/user/shinobi-blogs?language=${lang}&per_page=10`,
  );
};
const shinobiBlogListApi = (per_page = 10, lang = languageMapping['en-US']) => {
  return axios.get(
    `https://api.himegamiprotocol.org/api/v1/user/shinobi-blogs?language=${lang}&per_page=${per_page}`,
  );
};

export {blogListApi, shinobiBlogListApi};
